import { feathers } from '@/feathers-client';
import axios from 'axios';
import { accountsLogin, accountsLogout } from '@/Authentication/accounts';

/**
 * Controls authentication.
 */
export default {
  namespaced: true,
  state: {
    currentUser: null,
    accessToken: null,
    marketingToken: null,
  },
  getters: {
    isLoggedIn: state => {
      return !!(state.accessToken && state.currentUser);
    },
    currentUser: state => state.currentUser,
    accessToken: state => state.accessToken,
    marketingToken: state => state.marketingToken,
  },
  mutations: {
    loginSuccess(state, payload) {
      const { accessToken, user } = payload;
      state.currentUser = user;
      state.accessToken = accessToken;
    },
    logout(state) {
      state.currentUser = null;
      state.accessToken = null;
    },
    updateUser(state, payload) {
      const { user } = payload;
      state.currentUser = user;
    },
    marketingTokenSuccess(state, payload) {
      const { evocalize_token } = payload;
      state.marketingToken = evocalize_token;
    },
  },
  actions: {
    async login({ dispatch }, credentials) {
      const { email, password } = credentials;
      const response = await feathers.authenticate({
        strategy: 'local',
        email,
        password,
      });
      if (response && response.user) {
        window.gtag('set', { user_id: response.user.id });
      }
      await accountsLogin(credentials.email, credentials.password);
      return dispatch('validateToken');
    },
    validateToken({ commit }) {
      return axios
        .get(
          `${process.env.VUE_APP_AUTHENTICATION_API_BASE_URL}/validate-token?app=crm`,
        )
        .then(({ data }) => {
          commit('loginSuccess', { accessToken: null, user: data.token.oauser });
        });
    },
    logout({ commit }) {
      commit('logout');
      accountsLogout();
    },
    loginSuccess({ commit }, payload) {
      commit('loginSuccess', payload);
    },
    async getMarketingToken({ commit }) {
      const response = await axios.get(`${process.env.VUE_APP_AUTHENTICATION_API_BASE_URL}/evocalize-token`);
      commit('marketingTokenSuccess', response.data);
    }
  },
};
